import * as React from "react";
import { AuditList } from "../common/AuditList";

const ProductEventAudit = () => <AuditList resource="product-events" />;

export default ProductEventAudit;
